/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserEventRequest} from '../models/UserEventRequest';

export interface TrackUserEvents$Request {
    userEventRequest: UserEventRequest;
}

export interface TrackUserEvents$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const trackUserEventsRequest = createAction<PayloadData<void, TrackUserEvents$Request>>('TRACK_USER_EVENT__TRACK_USER_EVENTS__REQUEST');
export const trackUserEventsSuccess = createAction<PayloadData<void, TrackUserEvents$Request>>('TRACK_USER_EVENT__TRACK_USER_EVENTS__SUCCESS');
export const trackUserEventsFailure = createAction<PayloadData<Error, TrackUserEvents$Request, true>>('TRACK_USER_EVENT__TRACK_USER_EVENTS__FAILURE');

export const trackUserEventsActions = [
    trackUserEventsRequest,
    trackUserEventsSuccess,
    trackUserEventsFailure
] as const;

/**
 * @param {UserEventRequest} meta.userEventRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const trackUserEvents = (meta: TrackUserEvents$Request, config?: TrackUserEvents$Config) => {
    return {
        CALL_API: {
            types: trackUserEventsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/admin/track-event`,
            TRANSPORT_REQUEST_BODY: meta.userEventRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

